<template>
  <div class="sb-minibrowser__breadcrumbs">
    <SbBreadcrumbs
      :items="items"
      disableLinkNavigation
      @item-click="({ index, event }) => navigateTo(event, index)"
    >
      <template #root-item>
        <a
          href="#"
          :data-testid="`${dataTestid}-item-root`"
          class="sb-breadcrumbs__link"
          @click.prevent="clearNavigation"
        >
          {{ 'Root' }}
        </a>
      </template>
    </SbBreadcrumbs>
  </div>
</template>

<script lang="ts" setup>
import { SbBreadcrumbs } from '../../Breadcrumbs'
import { useMinibrowser } from '../utils'
import type { BreadcrumbItem } from '../../Breadcrumbs/types'

import { computed, useAttrs } from 'vue'

type SbMinibrowserSearchProps = {
  /**
   * List of breadcrumb items
   */
  items: BreadcrumbItem[]
}

const props = defineProps<SbMinibrowserSearchProps>()

const { context } = useMinibrowser()

const dataTestid = computed(
  () => useAttrs()['data-testid'] || 'sb-mini-browser-breadcrumbs',
)

const lastIndex = computed(() => props.items.length - 1)

const clearNavigation = (event: Event) => {
  event.preventDefault()
  event.stopPropagation()
  context.value.clearNavigation()
}

const navigateTo = (event: Event, index = 0) => {
  event.preventDefault()
  event.stopPropagation()
  context.value.navigateTo(index)
}
</script>
